import O1HD from "../../../../../engines/gameEngine";
import ShopLotteryGGLPrefab, {ShopHongPrizeEntity} from "./ShopLotteryGGLPrefab";
import ShopGglItemNode from "./ShopGglItemNode";
import Graphics = cc.Graphics;

const {ccclass, property} = cc._decorator;

@ccclass
export default class ShopGGLNode extends cc.Component {

    @property(cc.Node)
    touchNode : cc.Node = null;
    @property(cc.Node)
    maskNode : cc.Node = null;
    @property({type:cc.Prefab,displayName:"item预制体"})
    newGGLItemPrefab : cc.Prefab = null;
    @property({type:cc.Node,displayName:"内容节点"})
    contentNode : cc.Node = null;
    @property(ShopLotteryGGLPrefab)
    mParentScript : ShopLotteryGGLPrefab = null;

    @property(cc.Label)
    lbPrizeNum1 : cc.Label = null;
    @property(cc.Label)
    lbPrizeNum2 : cc.Label = null;
    @property(cc.Label)
    lbPrizeNum3 : cc.Label = null;

    @property({type:cc.Node,displayName:""})
    judgePrizeNode : cc.Node = null;
    @property({type:cc.Node,displayName:""})
    judgePrize1Node : cc.Node = null;
    @property({type:cc.Node,displayName:""})
    judgePrize2Node : cc.Node = null;


    //当前奖项
    currPrizeArray : number[] = [];
    //已经打开的奖项
    hasOpenArray : string[] = [];

    onLoad () {
        cc.macro.ENABLE_MULTI_TOUCH = true;
        this.node.getChildByName("bg").getChildByName("touchNode").on("touchstart",this.touchStart.bind(this) );
        this.node.getChildByName("bg").getChildByName("touchNode").on("touchmove",this.touchMove.bind(this) );
        O1HD.on("ShopGGLNode.reset" , this.reset , this );
    }


    start () {
        this.reset();
    }

    refreshData(){
        //快速求出三个不重复的随机数（1-100）
        let random1 = Math.floor( Math.random() * 99 ) + 1;
        let tempNum2 = 99 - random1;
        let random2 = tempNum2 > random1 ? Math.floor( Math.random() * (99-tempNum2)) + random1+1 : Math.floor( Math.random() * random1 );
        let random3 = 0;
        if ( random2 - random1 < 0 ) {
            //左
            let tempNum3 = random1 - random2;
            random3 = tempNum3 > random2 ? Math.floor( Math.random() * ( random1-tempNum3)) + random2+1 : Math.floor( Math.random() * random2 );
        }else{
            //右
            let tempNum3 = 99 - random2;
            random3 = tempNum3 > random2 ? Math.floor( Math.random() * ( 99-random2)) + random2+1 : Math.floor( Math.random() * (random2 - random1) ) + random1 ;
        }
        this.currPrizeArray.push( random1 );
        this.currPrizeArray.push( random2 );
        this.currPrizeArray.push( random3 );

        this.lbPrizeNum1.string = `${random1}`;
        this.lbPrizeNum2.string = `${random2}`;
        this.lbPrizeNum3.string = `${random3}`;
        for ( let i = 0 ; i < 9 ; i ++ ) {
            let newGglItemNode = cc.instantiate( this.newGGLItemPrefab );
            newGglItemNode.getComponent( ShopGglItemNode ).bindData( this , `c${i}` , this.currPrizeArray );
            this.contentNode.addChild( newGglItemNode );
        }
    }

    touchStart(e:cc.Event.EventTouch){

    }
    touchMove(e:cc.Event.EventTouch){
        if ( e.getTouches().length > 1 ) {
            //多点触控
            let point1Pos = e.getTouches()[0].getLocation();
            let point2Pos = e.getTouches()[1].getLocation();
            this.checkJudgeLine( point1Pos,point2Pos );
            this._addLine( this.maskNode.convertToNodeSpaceAR( point1Pos ) ,this.maskNode.convertToNodeSpaceAR( point2Pos ));
            O1HD.emit("ShopGglItemNode.checkJudge" , point1Pos ,point2Pos );
        }else{
            //单点操作
            let distance = Math.abs( Math.floor( e.getLocation().sub( e.getPreviousLocation() ).mag() ) );
            if ( distance > 5 ) {
                //补点操作
                for ( let num = 0 ; num < distance ; num += 3 ) {
                    let subLocation : cc.Vec2 = e.getLocation().sub( e.getPreviousLocation() );
                    let actualLocation = e.getPreviousLocation().add( subLocation.div( distance ).mul( num ) );
                    this._addCircle( this.maskNode.convertToNodeSpaceAR( actualLocation ) );
                    O1HD.emit("ShopGglItemNode.checkJudgeNode" , actualLocation );
                }
            }
            this._addCircle( this.maskNode.convertToNodeSpaceAR( e.getLocation() ) );
            this.checkJudgeNode( e.getLocation() );
            O1HD.emit("ShopGglItemNode.checkJudgeNode" , e.getLocation() );
        }
    }

    private flagPrizeOpenFlag : boolean = false;
    private flagPrizeOpenFlag1 : boolean = false;
    private flagPrizeOpenFlag2 : boolean = false;
    /**
     * 检查是否过了 判断点
     * @param pos
     * @private
     */
    checkJudgeNode ( pos : cc.Vec2 ) {
        if ( this.judgePrizeNode.getBoundingBoxToWorld().contains( pos )  && this.flagPrizeOpenFlag == false ) {
            this.flagPrizeOpenFlag = true;
            O1HD.emit("ShopGglItemNode.triggerFlagPrizeOpen" , this.currPrizeArray[0] );
        }

        if ( this.judgePrize1Node.getBoundingBoxToWorld().contains( pos )  && this.flagPrizeOpenFlag1 == false ) {
            this.flagPrizeOpenFlag1 = true;
            O1HD.emit("ShopGglItemNode.triggerFlagPrizeOpen" , this.currPrizeArray[1] );
        }

        if ( this.judgePrize2Node.getBoundingBoxToWorld().contains( pos )  && this.flagPrizeOpenFlag2 == false ) {
            this.flagPrizeOpenFlag2 = true;
            O1HD.emit("ShopGglItemNode.triggerFlagPrizeOpen" , this.currPrizeArray[2] );
        }
    }

    checkJudgeLine( pos1 : cc.Vec2 , pos2 : cc.Vec2 ){
        if ( cc.Intersection.lineRect( pos1,pos2,this.judgePrizeNode.getBoundingBoxToWorld() )  && this.flagPrizeOpenFlag == false ) {
            this.flagPrizeOpenFlag = true;
            O1HD.emit("ShopGglItemNode.triggerFlagPrizeOpen" , this.currPrizeArray[0] );
        }

        if ( cc.Intersection.lineRect( pos1,pos2,this.judgePrize1Node.getBoundingBoxToWorld() )  && this.flagPrizeOpenFlag1 == false ) {
            this.flagPrizeOpenFlag1 = true;
            O1HD.emit("ShopGglItemNode.triggerFlagPrizeOpen" , this.currPrizeArray[1] );
        }

        if ( cc.Intersection.lineRect( pos1,pos2,this.judgePrize2Node.getBoundingBoxToWorld() )  && this.flagPrizeOpenFlag2 == false ) {
            this.flagPrizeOpenFlag2 = true;
            O1HD.emit("ShopGglItemNode.triggerFlagPrizeOpen" , this.currPrizeArray[2] );
        }
    }

    //效果渲染
    maskGraphicsPos1:cc.Vec2[] = [];
    _addCircle(pos:cc.Vec2){
        // @ts-ignore
        // this.maskNode.getComponent(cc.Mask)._graphics;
        this.maskNode.getComponent(cc.Mask)._graphics.circle (pos.x,pos.y, 20 );
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.fill();
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.stroke();
        this.maskGraphicsPos1.push(pos);
    }

    _addLine( pos1:cc.Vec2 , pos2 : cc.Vec2 ){
        // @ts-ignore
        let graphics : cc.Graphics = this.maskNode.getComponent(cc.Mask)._graphics;
        graphics.lineWidth = 50;
        graphics.lineCap = Graphics.LineCap.ROUND;
        graphics.strokeColor = cc.color( 20,20,20 );
        graphics.moveTo( pos1.x , pos1.y );
        graphics.lineTo( pos2.x , pos2.y );
        graphics.stroke();
    }

    /**
     * 开奖
     */
    openPrize( hongDefine : ShopHongPrizeEntity , node : cc.Node ){
        if ( hongDefine.flag ) {
            O1HD.getManagers().soundMgr.playSound("gglAddCoins").then();
            O1HD.getServices().userSrv.setCoins( hongDefine.prize , true , node );
        }
        this.hasOpenArray.push( hongDefine.uniqueId );
    }

    reset(){
        O1HD.emit("ShopGglItemNode.remove" );
        this.hasOpenArray = [];
        this.currPrizeArray = [];
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.clear();
        this.maskNode.opacity = 255;
        this.maskNode.active = true;
        this.flagPrizeOpenFlag = false;
        this.flagPrizeOpenFlag1 = false;
        this.flagPrizeOpenFlag2 = false;
        this.refreshData();
    }

}
